export default __webpack_public_path__ + "static/media/warning.b8ec8106.svg";